import React from 'react';
import { Info } from 'lucide-react';
import { Popover, PopoverContent, PopoverTrigger } from './popover';
import './hint.css';

// Petite bulle « i » : un clic (ou Entrée) ouvre l'explication, en clair, au-dessus de tout (y compris des feuilles).
// `inline` : rendu en <span role="button"> pour vivre dans un <label> ou un <button> sans casser l'association HTML.
export const InfoTip = ({ title, children, testId, side = 'top', size = 'sm', className = '', inline = false }) => {
  if (!children) return null;
  const Trigger = inline ? 'span' : 'button';
  const extra = inline ? { role: 'button', tabIndex: 0, onKeyDown: (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.currentTarget.click(); } } } : { type: 'button' };
  return (
    <Popover>
      <span className="contents" onClick={(e) => { e.stopPropagation(); e.preventDefault(); }}>
        <PopoverTrigger asChild>
          <Trigger {...extra} className={`ui-infotip is-${size} ${className}`} aria-label={title ? `Explication : ${title}` : 'Explication'} data-testid={testId}>
            <Info size={size === 'md' ? 13 : 11} aria-hidden />
          </Trigger>
        </PopoverTrigger>
      </span>
      <PopoverContent side={side} collisionPadding={12} className="ui-infotip-pop z-[95] w-[min(92vw,300px)] rounded-2xl border-0 p-3.5 shadow-2xl" data-testid={testId ? `${testId}-content` : undefined} onClick={(e) => e.stopPropagation()}>
        {title && <p className="ui-infotip-title">{title}</p>}
        <div className="ui-infotip-body">{children}</div>
      </PopoverContent>
    </Popover>
  );
};

// Libellé de champ + bulle « i » optionnelle (même ligne).
export const FieldLabel = ({ children, help, helpTitle, testId, htmlFor }) => {
  const title = helpTitle || (Array.isArray(children) ? children.filter((c) => typeof c === 'string').join('') : (typeof children === 'string' ? children : undefined));
  return (
    <label htmlFor={htmlFor} className="ui-fieldlabel">
      <span>{children}</span>
      {help && <InfoTip title={title} testId={testId}>{help}</InfoTip>}
    </label>
  );
};

export default InfoTip;
